import createPersistedState from 'vuex-persistedstate';

import Vue from 'vue';
import Vuex from 'vuex';

//qmsStore
import qmsStore from './qms';
import commonStore from './common';
import queueRecordCountStore from '@common/QueueRecordCount/store';
import tableDataManagementStore from '@common/TableDataManagement/store';
import widgetStore from '@common/Widget/store';
import widgetMasterStore from '@common/WidgetMaster/store';
import dicMsgManagementStore from '@common/DicMsgManagement/store';
import notificationStore from '@common/Notification/store';
import userManagementStore from '@common/UserManagement/store';
import userGroupManagementStore from '@common/UserGroupManagement/store';
import programRegistrationStore from '@common/ProgramRegistration/store';
import processRegistrationStore from '@common/ProcessRegistration/store';
import mappingProgramProcessStore from '@common/MappingProgramProcess/store';
import loginHistoryStore from '@common/LoginHistory/store';
import userGroupMapStore from '@common/UserGroupMap/store';
import userAccessStore from '@common/UserAccess/store';
import screenUsageStore from '@common/ScreenUsage/store';
import menuManagementStore from '@common/MenuManagement/store';
import syncManagementStore from '@common/SyncManagement/store';
import errorLogStore from '@common/ErrorLog/store';
import commonCodeStore from '@common/CommonCode/store';
import userGroupControlManagementStore from '@common/UserGroupControlManagement/store';
import registerReportingPointStore from '@common/RegisterReportingPoint/store';
import libraryDependencyStore from '@common/LibraryDependency/store';
import controlManagementStore from '@common/ControlManagement/store';
import guideBoardStore from '@common/GuideBoard/store';
import sqlEditorStore from '@common/SQLEditor/store';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		//gqms store
		...qmsStore,
		commonStore,
		queueRecordCountStore,
		registerReportingPointStore,
		tableDataManagementStore,
		widgetStore,
		widgetMasterStore,
		dicMsgManagementStore,
		notificationStore,
		userManagementStore,
		userGroupManagementStore,
		programRegistrationStore,
		userGroupMapStore,
		processRegistrationStore,
		mappingProgramProcessStore,
		loginHistoryStore,
		userAccessStore,
		screenUsageStore,
		menuManagementStore,
		syncManagementStore,
		errorLogStore,
		commonCodeStore,
		userGroupControlManagementStore,
		libraryDependencyStore,
		controlManagementStore,
		guideBoardStore,
		sqlEditorStore
	},

	plugins: [
		//브라우저를 새로고침해도 Vuex의 Store가 날아가지 않도록 하는 플러그인
		createPersistedState({
			paths: ['commonStore']
		})
	]
});
